import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolderOpen,faHome,faUsers,faUserTie,faTasks,faIdBadge,faMapMarkedAlt,faInfo,faIndustry,faCaretSquareUp, faTree, faMapMarked, faCalendarDay, faDatabase, faSearch, faChartArea, faFolder, faMapMarkerAlt, faInfoCircle, faListAlt, faChartBar, faSeedling, faCheckSquare, faChartPie, faLayerGroup, faQuestionCircle, faLaptop, faFileDownload, faAddressBook, faGlobe } from '@fortawesome/free-solid-svg-icons'
library.add(faFolderOpen)
library.add(faHome)
library.add(faUsers)
library.add(faUserTie)
library.add(faTasks)
library.add(faIdBadge)
library.add(faMapMarkedAlt)
library.add(faInfo)
library.add(faIndustry)
library.add(faCaretSquareUp)
library.add(faTree)
library.add(faMapMarked)
library.add(faCalendarDay)
library.add(faDatabase)
library.add(faSearch)
library.add(faSearch)
library.add(faChartArea)
library.add(faFolder)
library.add(faMapMarkerAlt)
library.add(faInfoCircle)
library.add(faListAlt)
library.add(faChartBar)
library.add(faUsers)
library.add(faSeedling)
library.add(faCheckSquare)
library.add(faChartPie)
library.add(faLayerGroup)
library.add(faQuestionCircle)
library.add(faLaptop)
library.add(faFileDownload)
library.add(faAddressBook)
library.add(faGlobe)

Vue.component('font-awesome-icon', FontAwesomeIcon)